import type { AppCopy } from '../catalogs';

export const huAppCopy = {
  welcomeHeading: 'Hogyan segíthetek ma?',
  thinking: 'Gondolkodás',
  scrollToBottom: 'Görgessen lefelé',
  reasoning: 'okoskodás',
  reasoningInProgress: 'folyamatban',
  citationPages: 'Oldalak: {first}–{last}',
  citationTitle: 'Forrásrészlet',
  citationLoading: 'Forrás betöltése…',
  citationUnavailable: 'Az idézett szöveg nem érhető el, vagy már nincs hozzáférése.',
  citationOpen: 'Forrás megnyitása',
  citationCopied: 'Hivatkozás másolva',
  copy: 'Másolás',
  more: 'Többet',
  tryAgain: 'Próbáld újra',
  answerTruncated: 'A válasz elérte a hosszkorlátot, és megszakadt.',
  continueAnswer: 'Válasz folytatása',
  exportMarkdown: 'Exportálás Markdown néven',
  edit: 'Szerkesztés',
  cancel: 'Mégsem',
  update: 'Frissítés',
  previous: 'Előző',
  next: 'Következő',
  messagePlaceholder: 'Üzenet küldése…',
  projectHomePlaceholder: 'Új chat: {project}',
  sharedChatEveryone: 'A(z) {company} minden munkatársa olvashatja ezt a csevegést',
  sharedChatOnePerson: '1 személy olvashatja ezt a csevegést',
  sharedChatPeople: '{count} személy olvashatja ezt a csevegést',
  forkedChatPlaceholder: 'Folytassa a saját kapcsolataival…',
  newAnswer: 'Új válasz',
  messageInput: 'Üzenetbevitel',
  sendMessage: 'Üzenet küldése',
  stopGenerating: 'Hagyd abba a generálást',
  addAttachment: 'Melléklet hozzáadása',
  removeFile: 'Fájl eltávolítása',
  attachmentPreview: 'Melléklet előnézete',
  imageAttachmentPreview: 'Képmelléklet előnézete',
  image: 'Kép',
  openLink: 'link megnyitása',
  document: 'dokumentum',
  file: 'Fájl',
  attachment: 'mellékletet',
  uploadFailed: 'feltöltés sikertelen',
  uploading: 'feltöltés',
  toolIncomplete: 'Befejezetlen',
  toolActivity: 'Tevékenység',
  activityThinking: 'Gondolkodik…',
  activityWriting: 'Ír…',
  activityWaiting: 'Jóváhagyására vár',
  activityStopped: 'Leállítva',
  activityCouldNotFinish: 'Nem sikerült befejezni',
  activitySources: 'forrás',
  activityShowThinking: 'Gondolkodás megjelenítése',
  activityOpen: 'Tevékenység megnyitása',
  activitySteps: 'Lépések',
  activitySourcesTab: 'Források',
  activityUnavailable: 'Ez a tevékenység nem érhető el.',
  activityInput: 'Bemenet',
  activityOutput: 'Kimenet',
  activityNoSources: 'A válasz nem hivatkozott forrásokra.',
  activityApprovedByReply: 'Válaszával jóváhagyva',

  toolRunning: 'Folyamatban',
  toolComplete: 'Kész',
  toolNeedsApproval: 'Jóváhagyás szükséges',
  toolInput: 'Bemenet',
  toolCall: 'szerszámhívás',
  toolCalls: 'eszközhívások',
  openMenu: 'Menü megnyitása',
  closeMenu: 'Menü bezárása',
  close: 'Bezárás',
  showInTextField: 'Megjelenítés a szövegmezőben',
  settings: 'Beállítások',
  appearance: 'Megjelenés',
  themeLight: 'Világos',
  themeDark: 'Sötét',
  themeSystem: 'Rendszer',
  themeChoiceHelp:
    'Minden eszközödön érvényes. A Rendszer az egyes eszközök világos vagy sötét módját követi.',
  themeSaveFailed: 'Nem sikerült menteni a megjelenést, ezért nem változott. Próbáld újra.',
  toolUsed: 'Használt eszköz',
  toolCancelled: 'Törölt eszköz',
  toolResult: 'Eredmény:',
  toolError: 'Hiba:',
  toolCancelledReason: 'Törölt oka:',
  approvalAllow: 'Engedélyezze',
  approvalAlwaysAllow: 'Mindig engedélyezze',
  approvalDeny: 'Elutasítás',
  approvalAlwaysDeny: 'Mindig utasítsa el',
  approvalConfirm: 'Erősítse meg',
  approvalBack: 'Vissza',
  approvalApprovedResult: 'A felhasználó jóváhagyta',
  approvalDeniedResult: 'A felhasználó megtagadta az eszköz futtatását',
  logout: 'Jelentkezzen ki',
  loginOrCreateAccount: 'Bejelentkezés / Fiók létrehozása',
  newChat: 'Új chat',
  untitledChat: 'Névtelen chat',
  previousChats: 'Korábbi beszélgetések',
  openChat: 'Nyissa meg a csevegést {title}',
  moreActionsForChat: 'További műveletek a következőhöz: {title}',
  chatActions: 'Csevegési műveletek',
  closeChatActions: 'Csevegési műveletek bezárása',
  deleteChatQuestion: 'Törli a csevegést?',
  deleteChatDescription: 'A „{title}” csevegés véglegesen törlődik.',
  deleteChat: 'Csevegés törlése',
  keepChat: 'Csevegés megtartása',
  delete: 'Törölje',
  deleting: 'Törlés…',
  chatDeleteFailed: 'A csevegést nem sikerült törölni. Próbáld újra.',
  settingsDescription: 'Szabja személyre az asszisztens működését.',
  settingsDesktopDescription: 'Testreszabhatja, hogy az asszisztens hogyan válaszoljon Önnek.',
  personalization: 'Személyre szabás',
  personalizationDescription:
    'Szabja személyre az asszisztens által követett utasításokat minden válaszában.',
  languageAndRegion: 'Nyelv és régió',
  languageAndRegionDescription: 'Válassza ki a nyelvet és az időzónát.',
  memories: 'Emlékek',
  memoriesDescription:
    'Tekintse meg, szerkessze vagy törölje, hogy az asszisztens mire emlékszik Önről.',
  account: 'fiók',
  accountDescription: 'A fiók kezelése és az adatok végleges törlése.',
  backToSettings: 'Vissza a beállításokhoz',
  closeSettings: 'Zárja be a beállításokat',
  settingsCategories: 'Beállítások kategóriák',
  yourSettings: 'Az Ön beállításai',
  dataAndAccount: 'Adatok és számla',
  viewAndManageMemories: 'Tekintse meg és kezelje, hogy az asszisztens mire emlékszik',
  loginToUseMemories: 'A memóriák használatához jelentkezzen be',
  manageOrDeleteAccount: 'A fiók kezelése vagy törlése',
  unsavedChanges: 'Nem mentett módosításai vannak',
  unsavedCloseDescription: 'A beállítások bezárása elveti az ezen az oldalon lévő módosításokat.',
  unsavedBackDescription: 'Ha visszalép, elveti az ezen az oldalon található módosításokat.',
  continueEditing: 'Folytassa a szerkesztést',
  discardChanges: 'A változtatások elvetése',
  saveChanges: 'Módosítások mentése',
  localSettingsNote: 'Ebben a böngészőben mentve. Jelentkezzen be, hogy elmentse a fiókjába.',
  personality: 'Személyiség',
  personalityHelp: 'Egyéni utasításokat az asszisztens követ minden válaszban',
  personalityPlaceholder:
    'Például: Legyen tömör és konkrét. Göteborgban élek, és szeretem a vegetáriánus ételeket.',
  timezone: 'Időzóna',
  searchTimezone: 'Időzónák keresése…',
  automaticBrowser: 'Automatikus (böngésző)',
  saved: 'Mentett {date}',
  addMemory: 'Emlék hozzáadása',
  newMemory: 'Új emlék',
  memoryPlaceholder: 'Például: A rövid, konkrét válaszokat kedvelem.',
  editMemory: 'Emlék szerkesztése',
  saveMemory: 'Emlék mentése',
  deleteMemory: 'Emlék törlése',
  memorySaveFailed: 'A memóriát nem sikerült elmenteni. Próbáld újra.',
  memoryLimitReached: 'Legfeljebb 50 emléket menthetsz. Törölj egyet, mielőtt újat adnál hozzá.',
  memoryInvalid: 'Az emlékek nem tartalmazhatnak linkeket. Távolítsd el a linket, és próbáld újra.',
  memoryDeleteFailed: 'A memória nem törölhető. Próbáld újra.',
  memoryLoadFailed: 'Az emlékek betöltése nem sikerült.',
  loadingMemories: 'Emlékek betöltése…',
  emptyMemories:
    'Az asszisztens elmenti az Önnel kapcsolatos emlékeket, miközben beszél – mit szeret, hol él és mit csinál. Itt megtekintheti, szerkesztheti és törölheti őket.',
  deleteAccountHelp:
    'Véglegesen törölje a fiókot és az összes kapcsolódó csevegést, memóriát és beállítást.',
  deleteAccount: 'Fiók törlése',
  deleteAccountQuestion: 'Véglegesen törli a fiókot?',
  deleteAccountDescription:
    'Minden csevegés, üzenet, memória, beállítás és bejelentkezési hitelesítő adat törlődik. Ez a művelet nem vonható vissza.',
  deleteAccountConfirm: 'Igen, törölje a fiókomat',
  accountDeleteFailed: 'A fiókot nem sikerült törölni. Semmit sem távolítottak el – próbálja újra.',
  logoutEverywhereTitle: 'Minden eszköz',
  logoutEverywhereHelp:
    'Jelentkezzen ki minden eszközön és böngészőben, ahol a fiókja meg van nyitva, ezen is.',
  logoutEverywhere: 'Kijelentkezés mindenhol',
  logoutEverywhereQuestion: 'Kijelentkezik minden eszközön?',
  logoutEverywhereDescription:
    'Minden eszközön és böngészőben újra be kell jelentkeznie, ezen is. A csevegései és beállításai változatlanok maradnak.',
  loggingOut: 'Kijelentkezés…',
  logoutEverywhereFailed:
    'Nem tudtuk megerősíteni, hogy mindenhol kijelentkezett. Próbálja újra, vagy ellenőrizze egy másik eszközön, hogy még be van-e jelentkezve.',
  settingsSaveFailed: 'A beállításokat nem sikerült elmenteni. Próbáld újra.',
  customInstructions: 'Egyedi utasítások',
  notSet: 'Nincs beállítva',
  automaticLanguage: 'Automatikus nyelv',
  automaticTimezone: 'automatikus időzóna',
  appLanguage: 'Alkalmazás nyelve',
  appLanguageHelp:
    'Az alkalmazás teljes felületét és a dátumokat vezérli. Az asszisztens válaszai továbbra is azt a nyelvet követik, amelyen Ön ír.',
  automaticBrowserLanguage: 'Automatikus (böngésző nyelve)',
  previousLanguageChoice: 'Korábbi választás: {language} ({locale})',
  previousLanguageChoiceCode: 'Korábbi választás ({locale})',
  canvasCopyLink: 'Hivatkozás másolása',
  canvasLinkCopied: 'Hivatkozás kimásolva',
  actionUpdatedWithEdits: 'Frissítve az Ön módosításaival',
  activityStepsDone: 'one:lépés kész|other:lépés kész',
  activityResultsCount: 'one:találat|other:találat',
  canvasCopyLinkFailed: 'Nem sikerült másolni a hivatkozást',
  canvasOpenInAgent: 'Megnyitás itt: {agent}',
  canvasExpand: 'Kibontás',
  canvasExitFullView: 'Kilépés a teljes nézetből',
  webSourceUnread:
    'Hivatkozva ebben a válaszban. A Poneva nem olvasta el ezt az oldalt, ezért itt nincs mit megjeleníteni.',
  webSourceOpenOriginal: 'Eredeti megnyitása',
  toolProgressSettings: 'A beállításai módosítása…',
  toolProgressAgent: 'Az ügynök létrehozása…',
  toolProgressConnections: 'Kapcsolódási lehetőségek keresése…',
  toolProgressResult: 'Az eredmény előkészítése…',
  toolProgressClarification: 'Pontosítás előkészítése…',
  toolProgressKnowledge: 'Javasolt tudásfrissítés előkészítése…',
  toolProgressQuestion: 'Kérdés előkészítése az Ön számára…',
  toolProgressSkill: 'A Skill formálása…',
  toolErrorSettings: 'A beállításai nem módosultak.',
  toolErrorAgent: 'Az ügynököt nem sikerült létrehozni.',
  toolErrorConnections: 'A kapcsolódási lehetőségeket nem sikerült betölteni.',
  toolErrorResult: 'Az eredmény nem lett mentve.',
  toolErrorClarification: 'A pontosítást nem sikerült előkészíteni.',
  toolErrorKnowledge: 'A javasolt tudásfrissítést nem sikerült előkészíteni.',
  toolErrorQuestion: 'A kérdést nem sikerült előkészíteni.',
  toolErrorSkill: 'A Skill piszkozatát nem sikerült menteni.',
  toolErrorOpenSettings: 'Beállítások megnyitása',
  toolErrorOpenAgents: 'Ügynökök megnyitása',
  toolErrorOpenConnections: 'Kapcsolatok megnyitása',
  toolStepIncomplete: 'Ez a lépés nem fejeződött be.',
  toolEarlierAttemptsFailed:
    'one:korábbi próbálkozás nem sikerült|other:korábbi próbálkozás nem sikerült',
} satisfies AppCopy;
